import { CurrencyIso } from '../../../converters/convertCurrencyIso';
import { RootState } from '../../RootState';

const selectOptionalCurrencyIso = (state: RootState): CurrencyIso | null =>
  state.settings.settings?.currencyIso ?? null;

export default selectOptionalCurrencyIso;
